import { render, staticRenderFns } from "./RootCauseReportForm.vue?vue&type=template&id=d5c36cce&scoped=true&"
import script from "./RootCauseReportForm.vue?vue&type=script&lang=js&"
export * from "./RootCauseReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c36cce",
  null
  
)

export default component.exports